import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../img/SDE.png'
import _imports_1 from '../img/toolkit.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-4a30540a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "body" }
const _hoisted_3 = { id: "screen-part1" }
const _hoisted_4 = { class: "column-layout" }
const _hoisted_5 = { id: "home-view-title" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "SDE",
  id: "sde"
}, null, -1))
const _hoisted_7 = { id: "home-view-title" }
const _hoisted_8 = { style: {"margin-top":"40px"} }
const _hoisted_9 = {
  class: "column-layout",
  style: {"margin-top":"40px"}
}
const _hoisted_10 = { class: "dialog-footer" }
const _hoisted_11 = {
  class: "small-module",
  style: {"margin-top":"40px"}
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "2000+", -1))
const _hoisted_13 = { id: "last-module" }
const _hoisted_14 = { class: "small-module" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "6+", -1))
const _hoisted_16 = {
  class: "small-module",
  id: "contact"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "screen-part2" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "toolkit",
    id: "toolkit"
  })
], -1))

import { useRouter } from 'vue-router';
import { reactive, ref, onMounted, onBeforeUnmount, computed } from 'vue'
import '../css/HomeViewCss.css';

import emailjs from 'emailjs-com';

import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const { t } = useI18n();
const { locale } = useI18n();

const isDesktop = ref(window.innerWidth >= 769);

const updateLayout = () => {
  isDesktop.value = window.innerWidth >= 769;
};

onMounted(() => {
  updateLayout();
  window.addEventListener('resize', updateLayout);
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', updateLayout);
});

const dialogWidth = computed(() => isDesktop.value ? '500px' : '300px');

const router = useRouter();

const goToProjects = () => {
  router.push("/projects");
};

const dialogFormVisible = ref(false)
const formLabelWidth = computed(() => {
  if (isDesktop.value) {
    return '140px';
  } else {
    return locale.value === 'zh' ? '80px' : '120px';
  }
});


const form = reactive({
  company_name: '',
  hr_name: '',
  email: '',
  message: ''
})

const handleCancel = function () {
  dialogFormVisible.value = false;
  clearFormData();
};

const handleConfirm = function () {
  dialogFormVisible.value = false;
  sendEmail();
};

const clearFormData = function () {
  form.company_name = '';
  form.hr_name = '';
  form.email = '';
  form.message = '';
};

const sendEmail = () => {
  const serviceID = 'service_p2z3s2j';
  const templateID = 'template_v9d60cm';
  const publicKey = 'yqBZvdpT48fsh_OgV';

  emailjs.send(serviceID, templateID, {
    company_name: form.company_name,
    hr_name: form.hr_name,
    email: form.email,
    message: form.message
  }, publicKey)
    .then((response) => {
      console.log('SUCCESS!', response.status, response.text);
      dialogFormVisible.value = false;
      clearFormData();
      alert(t('homeView.messageSentSuccessfully'));
    }, (error) => {
      console.error('FAILED...', error);
      alert(t('homeView.messageSentFailed'));
    });
};



return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.$t('homeView.opening')), 1),
          _hoisted_6
        ]),
        _createElementVNode("h1", _hoisted_7, _toDisplayString(_ctx.$t('homeView.myName')), 1),
        _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t('homeView.description')), 1),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            type: "button",
            id: "hire_me",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (dialogFormVisible.value = true))
          }, _toDisplayString(_ctx.$t('homeView.hireMe')), 1),
          _createVNode(_component_el_dialog, {
            modelValue: dialogFormVisible.value,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((dialogFormVisible).value = $event)),
            title: _ctx.$t('homeView.contactMe'),
            width: dialogWidth.value
          }, {
            footer: _withCtx(() => [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_el_button, { onClick: handleCancel }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('homeView.cancel')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: handleConfirm
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('homeView.confirm')), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_form, { model: form }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('homeView.companyName'),
                    "label-width": formLabelWidth.value
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: form.company_name,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.company_name) = $event)),
                        autocomplete: "off"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label", "label-width"]),
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('homeView.yourName'),
                    "label-width": formLabelWidth.value
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: form.hr_name,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.hr_name) = $event)),
                        autocomplete: "off"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label", "label-width"]),
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('homeView.contactEmail'),
                    "label-width": formLabelWidth.value
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: form.email,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.email) = $event)),
                        autocomplete: "off"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label", "label-width"]),
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('homeView.message'),
                    "label-width": formLabelWidth.value
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: "textarea",
                        rows: 6,
                        modelValue: form.message,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.message) = $event)),
                        autocomplete: "off"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label", "label-width"])
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            _: 1
          }, 8, ["modelValue", "title", "width"]),
          _createElementVNode("button", {
            type: "button",
            id: "projects",
            onClick: goToProjects
          }, _toDisplayString(_ctx.$t('homeView.projects')) + " ↗", 1)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('homeView.leetcode')), 1)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('homeView.experience')), 1)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.$t('homeView.contact')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('homeView.email')), 1)
          ])
        ])
      ]),
      _hoisted_17
    ])
  ]))
}
}

})